import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import NavbarPag from "../../components/NavbarPag";
import { es } from "date-fns/locale/es";
import { useData } from "../../contexts/DataContext";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../atoms/loading";
import Modal from "../../atoms/modal";
import db from "../../firebase";
import * as XLSX from "xlsx";
import citiesData from "../../cities/cities.json";
import {
  collection,
  onSnapshot,
  query,
  where,
  getDocs,
  Query,
  DocumentData,
  DocumentReference,
} from "firebase/firestore";
import { AgGridReact } from "ag-grid-react";
import Dropdown from "../../atoms/dropdown";
import EditOd from "../editOd";

interface Option {
  value: string;
  label: string;
}

interface Data {
  doc: string;
  field: string;
  where: number;
}
interface DataOd {
  Centro_de_costos: string;
  Destino: string;
  alto: string;
  ancho: string;
  bultos: string;
  ciudad: string;
  contacto: string;
  destinatario: string;
  direccion: string;
  email: string;
  fecha: string;
  guia: string;
  id: number;
  kilos: string;
  largo: string;
  observaciones: string;
  time: { seconds: number; nanoseconds: number }; // Firebase Timestamp
  uuid: number;
}
interface DataDeliver {
  destino: string;
  bultos: string;
  email: string;
  fecha: number;
  fechaReceived: number;
  receivingBultos: number;
  receivingStatus: number;
  state: number;
  uuid: number;
}
const AdminOd = () => {
  // Convertir el objeto a un array de opciones
  let lisState = ["INICIAL", "RETIRADO", "ENTREGADO", "NO ENTREGADO"];
  const [errorOd, setErrorOd] = useState(true);
  const [orders, setOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [titel, setTitel] = useState("");
  const [textButton, setTextButton] = useState("Cerrar");
  const location = useLocation();
  const [emailSearche, setEmailSearche] = useState("");
  const [oCitySearche, setOCitySearche] = useState("");
  const [dCitySearche, setDCitySearche] = useState("");
  const [statusOSearche, setStatusOSearche] = useState("");
  const [commentSearche, setCommentSearche] = useState("");
  const [refOd, setRefOd] = useState<DocumentReference>();
  const [refDe, setRefDe] = useState<DocumentReference>();
  const [lisNameUser, setLisNameUser] = useState<{ [key: string]: string }>({});
  const { setOd, profile } = useData();
  const [dataOd, setDataOd] = useState<DataOd>({
    Centro_de_costos: "",
    Destino: "",
    alto: "",
    ancho: "",
    bultos: "",
    ciudad: "",
    contacto: "",
    destinatario: "",
    direccion: "",
    email: "",
    fecha: "",
    guia: "",
    id: 0,
    kilos: "",
    largo: "",
    observaciones: "",
    time: { seconds: 0, nanoseconds: 0 },
    uuid: 0,
  });
  const [dataDeliver, setDataDeliver] = useState<DataDeliver>({
    destino: "",
    bultos: "",
    email: "",
    fecha: 0,
    fechaReceived: 0,
    receivingBultos: 0,
    receivingStatus: 0,
    state: 0,
    uuid: 0,
  });

  const ciudadesArray: Option[] = Object.entries(citiesData).map(
    ([key, value]) => ({
      value: key,
      label: value,
    })
  );
  const [nameClient, setNameClient] = useState<Option[]>([
    { label: "todos", value: "todos" },
  ]);
  const status: { label: string; value: string }[] = [];
  const commes: { label: string; value: string }[] = [
    { label: "Con", value: `Con` },
    { label: "Sin", value: `Sin` },
  ];
  lisState.forEach((e, i) => {
    console.log(e, i);
    status.push({ label: e, value: `${i}` });
  });

  const [colDefs, setColDefs] = useState([
    { field: "FECHA" },
    { field: "OD" },
    { field: "GUIA" },
    { field: "ESTADO" },
    { field: "CLIENTE" },
    { field: "CIUDAD" },
    { field: "DESTINO" },
    { field: "DIRECCION" },
    { field: "BULTOS" },
    { field: "KILOS" },
    { field: "CENTRO_DE_COSTOS" },
    { field: "OBSERVACIONES" },
  ]);

  const { rutInit, od } = useData();

  const navigate = useNavigate();
  useEffect(() => {
    console.log(profile);
    initData();
    if (rutInit === "") {
      navigate("/");
    }
  }, []);

  const initData = async () => {
    const dataName: Option[] = [];
    let lisUser: { [key: string]: string } = {};
    const q = query(collection(db, "users"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      console.log(doc.data());
      let email = doc.data()["email"];
      let name = doc.data()["name"];
      dataName.push({ value: doc.data()["email"], label: doc.data()["name"] });
      lisUser = { ...lisUser, [email]: name };
    });
    setNameClient(dataName);
    console.log(lisUser);
    setLisNameUser(lisUser);
  };
  //********************************** */
  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  });

  const [endDate, setEndDate] = useState(() => {
    const date = new Date();
    date.setHours(23, 59, 59, 999);
    return date;
  });

  const search = async () => {
    const filters = [];
    if (emailSearche !== "") {
      filters.push(where("email", "==", emailSearche));
    }
    if (oCitySearche !== "") {
      filters.push(where("ciudad", "==", oCitySearche));
    }
    if (dCitySearche !== "") {
      filters.push(where("Destino", "==", dCitySearche));
    }
    if (commentSearche !== "") {
      if (commentSearche === "Con")
        filters.push(where("observaciones", ">", ""));
      else filters.push(where("observaciones", "==", ""));
    }

    let q = query(
      collection(db, "orders"),
      where("time", ">=", startDate),
      where("time", "<=", endDate),
      ...filters
    );

    const filtersOd = [];
    if (statusOSearche !== "")
      filtersOd.push(where("state", "==", parseInt(statusOSearche)));

    const querySnapshot = await getDocs(q);
    //console.log(querySnapshot);

    const docsArray = querySnapshot.docs;
    let dataView: any = [];
    for (let i = 0; i < docsArray.length; i++) {
      console.log(docsArray[i].data());
      const uuid = docsArray[i].data()["uuid"];
      const qt = query(
        collection(db, "deliveries"),
        where("uuid", "==", uuid),
        ...filtersOd
      );
      const dataState = await getDocs(qt);
      dataState.forEach((doc) => {
        //console.log(docsArray[i].data()["email"]);

        //console.log(lisNameUser);
        const dataOrden = {
          FECHA: docsArray[i].data()["fecha"],
          GUIA: docsArray[i].data()["guia"],
          OD: docsArray[i].data()["uuid"],
          ESTADO: lisState[doc.data()["state"]],
          CLIENTE: lisNameUser[docsArray[i].data()["email"]],
          CIUDAD:
            citiesData[
              docsArray[i].data()["ciudad"] as keyof typeof citiesData
            ],
          DESTINO:
            citiesData[
              docsArray[i].data()["Destino"] as keyof typeof citiesData
            ],
          DIRECCION: docsArray[i].data()["direccion"],
          BULTOS: docsArray[i].data()["bultos"],
          KILOS: docsArray[i].data()["kilos"],
          CENTRO_DE_COSTOS: docsArray[i].data()["Centro_de_costos"],
          OBSERVACIONES: docsArray[i].data()["observaciones"],
        };
        // console.log(dataOrden);
        dataView.push(dataOrden);
      });
    }
    setOrders(dataView);
    //console.log(orders);
  };

  registerLocale("es", es);
  const descargar = () => {
    if (orders.length === 0) return;
    const data = [
      [
        "FECHA",
        "GUIA",
        "ESTADO",
        "CLIENTE",
        "CIUDAD",
        "DESTINO",
        "DIRECCION",
        "BULTOS",
        "KILOS",
        "CENTRO_DE_COSTOS",
        "OBSERVACIONES",
      ],
    ];
    orders.forEach((e) => {
      console.log("orders", e);
      data.push([
        e.FECHA,
        e.GUIA,
        e.ESTADO,
        e.CLIENTE,
        e.CIUDAD,
        e.DESTINO,
        e.DIRECCION,
        e.BULTOS,
        e.KILOS,
        e.CENTRO_DE_COSTOS,
        e.OBSERVACIONES,
      ]);
    });
    //console.log(selected.name);
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, startDate.toDateString() + ".xlsx");
  };
  const getFilters = (data: string, label: string) => {
    /**
     * const [emailSearche, setEmailSearche] = useState("");
  const [oCitySearche, setOCitySearche] = useState("");
  const [dCitySearche, setDCitySearche] = useState("");
  const [statusOSearche, setStatusOSearche] = useState("");
  const [commentSearche, setCommentSearche] = useState("");
     */
    console.log(label);

    console.log(data.split(":")[0]);

    if (label === "Ciudad de Origen") setOCitySearche(data.split(":")[0]);
    else if (label === "Ciudad de destino") setDCitySearche(data.split(":")[0]);
    else if (label === "Estado Od") setStatusOSearche(data.split(":")[0]);
    else if (label === "Comentarios") setCommentSearche(data.split(":")[0]);
    else setEmailSearche(data.split(":")[0]);
  };

  const searchOd = async (uuid: string) => {
    console.log(uuid);
    setLoading(true);

    const deliveries: any[] = [];
    const orders: any[] = [];
    const refDeliver: any[] = [];
    const refOders: any[] = [];
    const qt = query(
      collection(db, "deliveries"),
      where("uuid", "==", parseInt(uuid))
    );
    const deliver = await getDocs(qt);
    deliver.forEach((doc) => {
      deliveries.push(doc.data());
      refDeliver.push(doc.ref);
    });

    const q = query(
      collection(db, "orders"),
      where("uuid", "==", parseInt(uuid))
    );
    const order = await getDocs(q);
    order.forEach((doc) => {
      orders.push(doc.data());
      refOders.push(doc.ref);
    });

    console.log("Deliveries:", deliveries[0]);

    setDataOd({ ...orders[0] });
    setDataDeliver({ ...deliveries[0] });
    setRefOd(refOders[0]);
    setRefDe(refDeliver[0]);
  };
  const backAdmi = () => {
    setLoading(false);
    search();
  };
  return (
    <div className={errorOd ? "w-screen   bg-neutral-200" : ""}>
      {showModal && (
        <Modal
          message={message}
          titel={titel}
          onClick={() => setShowModal(false)}
          textButton={textButton}
        />
      )}
      {/* Loader */}
      {
        //loading && <Loading />
      }
      {/* navbar */}
      <NavbarPag />
      <div className=" h-full bg-neutral-200 flex flex-col items-center">
        <div className=" w-11/12">
          <h2 className="text-2xl text-center p-3"> Administrar OD</h2>
          {!loading && (
            <>
              {" "}
              <article className=" bg-slate-50">
                <div className="flex p-4">
                  <div className="pr-8 pt-2">Fecha de Inicio</div>
                  <DatePicker
                    selected={startDate}
                    onChange={(date: any) => setStartDate(date)}
                    locale="es"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
                  />
                  <div className="pr-8 pt-2">Fecha de final</div>
                  <DatePicker
                    selected={endDate}
                    onChange={(date: any) => setEndDate(date)}
                    locale="es"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
                  />
                  <div className="pr-8 pt-2">Usuario</div>
                  <Dropdown
                    primariOptions="-- Todos --"
                    label=""
                    options={nameClient}
                    onSelect={getFilters}
                    class_name="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
                  />
                </div>
                <div className="flex p-4">
                  <Dropdown
                    primariOptions="-- Todas --"
                    label="Ciudad de Origen"
                    options={ciudadesArray}
                    onSelect={getFilters}
                    class_name="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
                  />

                  <Dropdown
                    primariOptions="-- Todas --"
                    label="Ciudad de destino"
                    options={ciudadesArray}
                    onSelect={getFilters}
                    class_name="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
                  />
                  <Dropdown
                    primariOptions="-- Todas --"
                    label="Estado Od"
                    options={status}
                    onSelect={getFilters}
                    class_name="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
                  />
                  <Dropdown
                    primariOptions="-- Todos --"
                    label="Comentarios"
                    options={commes}
                    onSelect={getFilters}
                    class_name="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
                  />
                </div>

                <div className="flex p-4">
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-10 mb-5"
                    onClick={search}
                  >
                    Buscar
                  </button>
                </div>
              </article>
              <h2 className="text-2xl text-center p-3"> seleccionar OD</h2>
              <article className=" h-[45rem] pt-1">
                <div className="ag-theme-quartz" style={{ height: "65%" }}>
                  <AgGridReact
                    rowData={orders}
                    columnDefs={colDefs}
                    onCellClicked={(event) => {
                      searchOd(event.data.OD);
                    }}
                  />
                </div>
              </article>
            </>
          )}
          {loading && (
            <>
              <EditOd
                cancel={setLoading}
                dataDeliver={dataDeliver}
                dataOd={dataOd}
                setDataDeliver={setDataDeliver}
                setDataOd={setDataOd}
                refDe={refDe}
                refOd={refOd}
                backAdmi={backAdmi}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminOd;
